import iconsPath from '@gitlab/svgs/dist/icons.svg';

const createButton = function () {
  let title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Insert the code snippet';
  let iconId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'insert';
  const button = document.createElement('button');
  button.type = 'button';
  button.classList.add('btn', 'btn-default', 'btn-md', 'gl-button', 'btn-default-secondary', 'btn-icon');
  button.dataset.title = title;
  button.setAttribute('aria-label', title);

  // Create an SVG element with the correct namespace
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('role', 'img');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('gl-button-icon', 'gl-icon', 's16');

  // Create a 'use' element with the correct namespace
  const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
  use.setAttribute('href', `${iconsPath}#${iconId}`);
  svg.appendChild(use);
  button.appendChild(svg);
  return button;
};

export { createButton };
